import { Link } from 'react-router-dom';
import { ArrowRight, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { MembershipTier, TIER_INFO } from '@/types/membership';
import { useMembership } from '@/contexts/MembershipContext';

interface UpgradePromptProps {
  requiredTier: MembershipTier;
  feature?: string;
}

export function UpgradePrompt({ requiredTier, feature }: UpgradePromptProps) {
  const { tier } = useMembership();
  const requiredInfo = TIER_INFO[requiredTier];
  const currentInfo = TIER_INFO[tier];

  return (
    <div className="flex min-h-[50vh] items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-muted p-4">
              <Lock className="h-8 w-8 text-muted-foreground" />
            </div>
          </div>
          <CardTitle className="text-2xl">
            {feature ? `${feature} requires ${requiredInfo.title}` : `${requiredInfo.title} Required`}
          </CardTitle>
          <CardDescription>
            You're currently on the <strong>{currentInfo.title}</strong> tier. 
            Upgrade to <strong>{requiredInfo.title}</strong> to access this feature.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg bg-muted/50 p-4">
            <h4 className="font-medium mb-2">{requiredInfo.title} includes:</h4>
            <ul className="space-y-1 text-sm text-muted-foreground">
              {requiredInfo.features.map((feature, index) => (
                <li key={index}>• {feature}</li>
              ))}
            </ul>
          </div>
          <Button asChild className="w-full">
            <Link to="/settings">
              Upgrade in Settings
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
